import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ProductDescriptionCellContainer } from '../../containers/ProductDescriptionCellContainer/ProductDescriptionCellContainer';
import { ProductNameCellContainer } from '../../containers/ProductNameCellContainer/ProductNameCellContainer';
import { UrlHelpers } from '../../service/UrlHelpers';
import { campaigns, GRID_PREFIX } from '../../typings/common';
import { GridCellProps, GridColumnDecl, GridScreenUrlSearchQueryParams } from '../../typings/grid';
import { Product, ProductsListColumnKeys } from '../../typings/products';

import * as keyset from './productsList.i18n';

const i18n = i18nFactory(keyset);

const WIDTH_ID = 150;
const WIDTH_NAME = 200;
const WIDTH_DESCRIPTION = 650;

const tableCellProductId: GridColumnDecl<Product> = {
    title: i18n('id'),
    key: ProductsListColumnKeys.ID,
    width: WIDTH_ID,
    isResizable: false,
    fixed: true,
    isSortable: true,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Product>) => <div>{item.id}</div>)
};

const tableCellProductName: GridColumnDecl<Product> = {
    title: i18n('product-name'),
    key: ProductsListColumnKeys.PRODUCT_NAME,
    width: WIDTH_NAME,
    isResizable: false,
    fixed: true,
    flexGrow: 1,
    isSortable: true,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Product>) => (
        <ProductNameCellContainer
            name={item.productName}
            access={item.productAccess}
            placeIds={item.productPlaceIds}
            link={UrlHelpers.createNewDirectLink(UrlHelpers.createNewDirectUrlPathByParams(GRID_PREFIX, campaigns), {
                [GridScreenUrlSearchQueryParams.ulogin]: item.ulogin
            })}
        />
    ))
};

const tableCellProductDescription: GridColumnDecl<Product> = {
    title: i18n('product-description'),
    key: ProductsListColumnKeys.PRODUCT_DESCRIPTION,
    width: WIDTH_DESCRIPTION,
    isResizable: false,
    flexGrow: 5,
    isSortable: false,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Product>) => (
        <ProductDescriptionCellContainer product={item} />
    ))
};

export function getProductsListItems(): GridColumnDecl<Product>[] {
    return [tableCellProductId, tableCellProductName, tableCellProductDescription];
}
